export default __webpack_public_path__ + "static/media/550.b109a4b7.gif";